/** Initial state for Exhibition Logistics RFQ (website). */

export const EL_URGENCY_OPTIONS = ['', 'Standard', 'Express', 'Urgent'];

export const EL_WEIGHT_UNIT_OPTIONS = ['KG', 'LB', 'MT', 'TON'];

export const EL_DIMENSION_UNIT_OPTIONS = ['CM', 'IN', 'M', 'FT'];

export function formatExhibitionDimensionsDisplay(source) {
  const length = source?.dimensionLength;
  const width = source?.dimensionWidth;
  const height = source?.dimensionHeight;
  const unit = source?.dimensionUnit || 'CM';
  const hasLength = length != null && String(length).trim() !== '';
  const hasWidth = width != null && String(width).trim() !== '';
  const hasHeight = height != null && String(height).trim() !== '';
  if (hasLength && hasWidth && hasHeight) {
    return `${length} x ${width} x ${height} ${unit}`;
  }
  const legacy = String(source?.dimensionsLwh || '').trim();
  return legacy || '';
}

export function hasPartialExhibitionDimensions(form) {
  const values = [form?.dimensionLength, form?.dimensionWidth, form?.dimensionHeight].map((value) =>
    String(value ?? '').trim(),
  );
  const filled = values.filter(Boolean).length;
  return filled > 0 && filled < 3;
}

export const EL_PACKAGING_OPTIONS = [
  '',
  'Crated',
  'Palletized',
  'Boxed',
  'Loose',
  'Shrink-wrapped',
  'Other',
];

export function getInitialExhibitionLogisticsRfqForm(companyId) {
  return {
    companyId: companyId != null && Number.isFinite(Number(companyId)) ? Number(companyId) : null,
    rfqReferenceNumber: '',
    contactPerson: '',
    contactNumber: '',
    companyName: '',
    companyEmail: '',
    exhibitionName: '',
    expoCode: '',
    setupDate: '',
    exhibitionStartDate: '',
    exhibitionEndDate: '',
    orgCountry: '',
    orgState: '',
    orgCity: '',
    orgPincode: '',
    orgAddress: '',
    venueCountry: '',
    venueState: '',
    venueCity: '',
    venuePincode: '',
    venueAddress: '',
    boothNumber: '',
    materialsDescription: '',
    totalWeightKg: '',
    totalWeightUnit: 'KG',
    numberOfPackages: '',
    dimensionLength: '',
    dimensionWidth: '',
    dimensionHeight: '',
    dimensionUnit: 'CM',
    declaredValueUsd: '',
    declaredValueCurrency: 'INR',
    packagingType: '',
    logisticsMode: '',
    urgencyLevel: '',
    specialHandling: '',
    returnToOrigin: false,
    additionalServices: {
      cargoInsurance: false,
      customsClearance: false,
      tempStorageVenue: false,
      boothSetupDismantling: false,
      realTimeTracking: false,
      labourSupport: false,
    },
  };
}

export function generateElRfqReference() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const r = Math.random().toString(36).slice(2, 8).toUpperCase();
  return `ELQ-${y}${m}${day}-${r}`;
}
